__turbopack_context__.v({
  "mandatory": "atc53G_mandatory",
  "root": "atc53G_root",
});
